module.exports = __webpack_public_path__ + "img/blacksam.69ba71b0.jpg";